// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1ilAA","alertIcon":"ConfirmModal_alertIcon__1Yztz"};